import c from "./index3.js";
import { openBlock as s, createElementBlock as t, createElementVNode as o, toDisplayString as r, createCommentVNode as a, pushScopeId as d, popScopeId as n } from "vue";
import "./index4.js";
import i from "./index5.js";
const p = (e) => (d("data-v-58b77e80"), e = e(), n(), e), _ = { class: "loading-bar" }, l = { class: "content" }, m = /* @__PURE__ */ p(() => /* @__PURE__ */ o("div", { class: "progress" }, null, -1)), h = { class: "message" }, v = {
  key: 0,
  class: "overlay"
};
function f(e, u, g, y, I, S) {
  return s(), t("div", _, [
    o("div", l, [
      m,
      o("div", h, r(e.message), 1)
    ]),
    e.showOverlay ? (s(), t("div", v)) : a("", !0)
  ]);
}
const B = /* @__PURE__ */ i(c, [["render", f], ["__scopeId", "data-v-58b77e80"]]);
export {
  B as default
};
//# sourceMappingURL=index2.js.map
